<template>
  <banners>
    <div class="mx-auto max-w-screen-lg px-6 md:px-10">
      <h2 class="my-8 text-left text-2xl text-dark-blue">Account Overview</h2>
      <tabs
        custom-class="tab-container"
        :tab-options="tabOptions"
        :set-hash="setHash"
        :default-tab="defaultTab"
      />
    </div>
  </banners>
</template>
<script>
import UsersIndex from '@/views/common/UsersIndex.vue';
import UsersInvitationsIndex from '@/views/common/UsersInvitationsIndex.vue';
import ShowProfile from '@/views/common/my-profile/ShowProfile.vue';
import Banners from '@/components/Banners.vue';
import Tabs from '@/components/Tabs.vue';
import TabMixin from '@/mixins/tabs';

export default {
  name: 'AccountOverview',
  components: {
    Tabs,
    Banners,
  },
  mixins: [TabMixin],
  data() {
    return {
      tabOptions: [
        {
          title: 'My Details',
          component: ShowProfile,
        },
        {
          title: 'Users',
          component: UsersIndex,
        },
        {
          title: 'Invitations',
          component: UsersInvitationsIndex,
        },
      ],
    };
  },
};
</script>
<style scoped>
.tab-item {
  @apply text-sm text-gray-over-dark;
}
.tab-item-active {
  @apply text-yellow-500 underline hover:text-yellow-600 !important;
  text-underline-offset: 3px;
}

.tab-container {
  @apply px-0 !important;
}
</style>
